import ApiService from '@/common/api.service'

const RESOURCE = 'form_inquiries'
const SupportService = {
  getList (params = {}) {
    return ApiService.query(RESOURCE, params)
  },
  getDetail (id, params = {}) {
    return ApiService.query(`supports/${id}/messages`, params)
  },
  reply (params) {
    ApiService.setHeaderImage('multipart/form-data')
    return ApiService.post(RESOURCE, params)
  }
}

export default SupportService
